import { useContext } from 'react';
import { ProviderContext } from '../context';

export function useWidgetContext() {
  const value = useContext(ProviderContext);

  if (!value) {
    throw new Error('ProviderContext not found.');
  }

  return value;
}
